module.exports = __webpack_public_path__ + "static/media/republicServices.f0d133bd.png";